import { createAction, props } from "@ngrx/store";
import { UserWithRoles } from "@hydrantid/acm-client";

export const UsersActions = {
    loadUsers: createAction("[Users] Load Users"),
    setUsers: createAction("[Users] Set Users", props<{ users: UserWithRoles[] }>()),
    setFilterValue: createAction("[Users] Set Filter Value", props<{ filterValue: string | undefined }>()),
};
